import { render, staticRenderFns } from "./MaterielLoadTime.vue?vue&type=template&id=685738cb"
import script from "./MaterielLoadTime.vue?vue&type=script&lang=js"
export * from "./MaterielLoadTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports